import PostFormCategoriesComp from './categories/categories.index';
import { Route, Routes } from 'react-router-dom';
import PostFormCityComp from './locations/locations.index';
import { PATH } from 'data';
import PostFormMainComp from './main/main.index';

function PostMobileForm2Comp() {
    return (
        <Routes>
            <Route
                path={PATH.panel.addPost.locations().key + '/*'}
                element={
                    <Routes>
                        <Route path={PATH.panel.addPost.main().key} element={<PostFormMainComp />} />
                        <Route index element={<PostFormCityComp />} />
                    </Routes>
                }
            />
            <Route index element={<PostFormCategoriesComp />} />
        </Routes>
    );
}

export default PostMobileForm2Comp;
